import { useEffect, useState } from "react";
import { Navbar } from "react-bootstrap";
import { useNavigate , useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearModalContent } from "src/redux/modules/modalEvent";
import { setUserToBeOnboarded } from "src/redux/actions/onboardingActions";
import { fetchUserInformationByIdV1 } from "src/api/user";
import { UserServiceSection } from "src/latest/src/constants/AppServerConfig";
import { OnboardingHeaderContent } from "./OnboardingHeaderContent";
import { AuthenticatedUserHeaderContent } from "./AuthenticatedUserHeaderContent";
import {
    isOnboardingHeader,
    isPreAuthNonOnboardingHeader,
} from "../../utils/headerHelper";
import "./header.scss";

type Props = {
    className?: string;
    expand?: string;
    onLogout: (reason: string) => void;
    handleSwitchRole: (role: string) => void;
};

export const Header = ({
    className = "",
    expand = "lg",
    onLogout,
    handleSwitchRole,
}: Props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { isAuthed, loggedInUser } = useSelector(
        (state: any) => state?.authentication
    );
    const { id } = loggedInUser;
    const configuration = useSelector((state: any) => state?.configuration);
    const { tenantLogo, fetchingAppConfig, tenantWebsite,tenantName } =
        configuration;
    const userId = useSelector(
        (state: any) => state?.questionnaireData?.initialMetadata?.user_id
    );
  
    const [currentUser, setCurrentUser] = useState<any>(null);
    const [showBoxShadow, setShowBoxShadow] = useState<boolean>(true);
    const {userToBeOnboarded} = useSelector((state:any) => state?.onboarding);
    
    useEffect(() => {
        if (location?.pathname?.includes("profile")) {
            setShowBoxShadow(false);
        } else {
            setShowBoxShadow(true);
        }
    }, [location]);

    const handleOnBrandClick = () => {
        const excludedURLs = ["initquestions", "sign-up", "login"];
        const matchedUrl = excludedURLs.filter((url) =>
            window.location.pathname?.includes(url)
        );

        const urlMatched = matchedUrl.length !== 0;

        if (!urlMatched) {
            navigate("/");
        }
    };

    const handleNav = (route: string) => {
        dispatch(clearModalContent());

        if (route === "/logout") {
            onLogout("MANUAL");

            return;
        }

        navigate(route);
    };

    useEffect(() => {
        getUserInformation();
        checkIfLoggedinUserIsOnboarding();
    }, [userId]);

    const checkIfLoggedinUserIsOnboarding = () => {
        if (userId === loggedInUser?.id) {
            dispatch(setUserToBeOnboarded(loggedInUser));
        }
    };

    const getUserInformation = async () => {
        if (
            userId &&
            userId !== id
        ) {
            const currentUserResponse = await fetchUserInformationByIdV1(
                userId,
                UserServiceSection.profile_display
            );

            dispatch(setUserToBeOnboarded(currentUserResponse));

            setCurrentUser({
                ...currentUserResponse,
            });
        }
    };

    useEffect(()=>{

        if(userToBeOnboarded !== null  && loggedInUser?.id !== userToBeOnboarded?.id){
            setCurrentUser(userToBeOnboarded);
        }
    },[userToBeOnboarded]);

    return (
        <>
        {location?.pathname?.includes("/verification") ? 

        <div className="pt-4 d-flex justify-content-center">
            <img
            src={`${decodeURIComponent(tenantLogo)}`}
            alt={tenantName}
            className='tenant-img w-auto'
            style={{height: "100px"}}
          />
        </div>
         :              
        <Navbar
            expand={expand}
            className={`header auth-header ${className} ${
                isPreAuthNonOnboardingHeader(isAuthed)
                    ? "justify-content-center"
                    : ""
            } ${showBoxShadow ? 'header-boxshadow ' : ''} ${(location?.pathname?.includes("/profile")) ? "scrollable-header"  : "fixedheader" }`}
        >
            <Navbar.Brand onClick={handleOnBrandClick}>
                <div className="header__logo">

                
                { loggedInUser?.id ? 
                   (!fetchingAppConfig && (
                        <img
                            src={`${decodeURIComponent(tenantLogo)}`}
                            alt={tenantName}
                            className="register__logo"
                        />
                    ) )
                    : 
                      <a
                    href={tenantWebsite}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {!fetchingAppConfig && (
                        <img
                            src={`${decodeURIComponent(tenantLogo)}`}
                            alt={tenantName}
                            className="register__logo"
                        />
                    )}
                </a>  }

                </div>
            </Navbar.Brand>

            {isOnboardingHeader() ? (
                <OnboardingHeaderContent
                    currentUser={currentUser}
                    handleNav={handleNav}
                 />
            ) : (
                <>
                    {isAuthed && (
                        <AuthenticatedUserHeaderContent
                            handleSwitchRole={handleSwitchRole}
                            handleNav={handleNav}
                         />
                    )}
                </>
            )}
        </Navbar>
        }
        </>
    );
};
